<template>
    <div class="modal fade" :id="'updateTempRankingCandidateModal' + _uid" role="dialog" aria-labelledby="updateTempRankingCanddateModalLabel" backdrop="static" data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header mt-3 mb-0">
                    <h5 class="modal-title" id="updateTempRankingCanddateModalLabel">{{$t('registers.events.evaluation.tempRanking.editor.update')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <TempRankingCandidateEditCard v-model="model"
                                                  v-if="showEditor"
                                                  :create="false"
                                                  :validateUniqueIdNumber="false"
                                                  :validateEgn="true"
                                                  @save="onSave"
                                                  @cancel="onCancel">
                    </TempRankingCandidateEditCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Participant } from '@/models/models';
    import TempRankingCandidateEditCard from './TempRankingCandidateEditCard';

    export default {
        components: {
            TempRankingCandidateEditCard
        },
        props: {
            value: {
                type: Object,
                required: false
            },
            show: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                showEditor: false,
                model: new Participant(),
            };
        },
        methods: {
            onClose() {
                this.$emit('onClose', { ...this.model });
                this.model = new Participant();
                this.$validator.reset();
            },
            hide() {
                $(this.$el).modal('hide');
            },
            onSave(model) {
                this.$emit('onEdit', model);
                this.onClose();
            },
            onCancel() {
                this.onClose();
            },
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Participant(this.value);
                    this.showEditor = true;
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px !important;
    }
</style>
